// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 725 ? "dh-basis-kart" : chunkId) + "-chunk-" + {"222":"48526e331a3e344021db","725":"e685d27a907b29c2532f"}[chunkId] + ".js";
};